export default __webpack_public_path__ + "static/media/GharBhada.98115a0a.png";